import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import staging1 from "../assets/BrocheImages.jpeg";
import staging2 from "../assets/BroucheImage2.jpeg";
import staging3 from "../assets/BroucheImage3.jpeg";
import staging4 from "../assets/BroucheImage4.jpeg";
import staging5 from "../assets/BrocheImage5.jpeg";

export function Home() {
  const navigate = useNavigate();
  const scrollRef = useRef(null as HTMLDivElement | null);

  const images = [staging1, staging2, staging3, staging4, staging5];

  useEffect(() => {
    const container = scrollRef.current;
    let scrollAmount = 0;

    const interval = setInterval(() => {
      if (!container) return;
      scrollAmount += 1;
      if (scrollAmount >= container.scrollWidth / 2) {
        scrollAmount = 0;
      }
      container.scrollLeft = scrollAmount;
    }, 20);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="px-6 md:px-10 py-12 md:py-16 space-y-16 font-sans">
      <div className="grid md:grid-cols-2 gap-10 md:gap-12 items-center max-w-6xl mx-auto">
        <div className="space-y-6">
          <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-[#2f3e2f] leading-tight">
            Helping Sydney & Newcastle properties achieve faster sales and
            stronger prices
          </h2>
          <p className="text-sm sm:text-base leading-relaxed text-[#4b5f4b] max-w-xl">
            Home staging brings your property to life, builds emotional
            connection, and supports faster sales at stronger prices.
          </p>
          <button
            type="button"
            onClick={() => navigate("/connect")}
            className="mt-2 px-8 py-3.5 bg-[#2f3e2f] text-[#faf9f6] rounded-xl shadow-md border border-[#243524] transition duration-150 ease-out hover:bg-[#243524] hover:-translate-y-0.5 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-[#6b8f71] focus:ring-offset-2 focus:ring-offset-[#f7f5ef]"
          >
            Book a Free Consultation
          </button>
        </div>

        <div
          ref={scrollRef}
          className="flex gap-4 overflow-x-hidden whitespace-nowrap rounded-2xl bg-[#faf9f6]/80 p-3 border border-[#e8e4d8] shadow-inner"
        >
          {[...images, ...images].map((src, i) => (
            <img
              key={`${src}-${i}`}
              src={src}
              alt=""
              className="h-52 sm:h-56 w-72 sm:w-80 object-cover rounded-xl flex-shrink-0 shadow-[0_8px_30px_rgba(47,62,47,0.12)] ring-1 ring-[#cfd8c3]/60"
            />
          ))}
        </div>
      </div>
    </section>
  );
}
